(() => {
  const initPage = (root) => {
    if (!root || root.dataset.cbpReady === "true") return;
    root.dataset.cbpReady = "true";

    const lazyVideo = root.querySelector(".cbp-lazy-video video");
    if (lazyVideo) {
      const loadVideo = () => {
        lazyVideo.querySelectorAll("source[data-src]").forEach((source) => {
          source.src = source.dataset.src;
          source.removeAttribute("data-src");
        });
        lazyVideo.load();
        lazyVideo.addEventListener(
          "loadedmetadata",
          () => {
            if (lazyVideo.currentTime === 0) lazyVideo.currentTime = 0.35;
            lazyVideo.play().catch(() => {});
          },
          { once: true },
        );
      };

      if ("IntersectionObserver" in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            loadVideo();
            observer.disconnect();
          },
          { threshold: 0.08 },
        );
        observer.observe(lazyVideo);
      } else {
        loadVideo();
      }
    }

    const variantSelect = root.querySelector("[data-variant-select]");
    const variantsNode = root.querySelector("[data-product-variants]");
    if (variantSelect && variantsNode) {
      const variants = JSON.parse(variantsNode.textContent || "[]");
      const price = root.querySelector("[data-product-price]");
      const compare = root.querySelector("[data-product-compare]");
      const images = root.querySelectorAll("[data-product-image]");
      const moneyFormat = window.Shopify?.currency?.active || "";

      const formatMoney = (cents) => {
        if (window.Shopify?.formatMoney && window.theme?.settings?.moneyFormat) {
          return window.Shopify.formatMoney(cents, window.theme.settings.moneyFormat);
        }
        return new Intl.NumberFormat(document.documentElement.lang || "en", {
          style: "currency",
          currency: moneyFormat || "USD",
        }).format(cents / 100);
      };

      variantSelect.addEventListener("change", () => {
        const variant = variants.find((item) => String(item.id) === variantSelect.value);
        if (!variant) return;
        if (price) price.textContent = formatMoney(variant.price);
        if (compare) {
          const showCompare = variant.compare_at_price > variant.price;
          compare.hidden = !showCompare;
          compare.textContent = showCompare ? formatMoney(variant.compare_at_price) : "";
        }
        if (variant.featured_image?.src) {
          images.forEach((image) => {
            image.src = variant.featured_image.src;
            image.srcset = "";
          });
        }
      });
    }
  };

  const initAll = () => {
    document.querySelectorAll("[data-cycling-bottle-page]").forEach(initPage);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initPage(event.target.querySelector("[data-cycling-bottle-page]"));
  });
})();